export class SearchPatientTotemRequest {
    public cpf: string | null = null;

    public cns: string | null = null;

    public isSchedule: boolean = false;
}